import hideMobileMenu from './hideMobileMenu';

export default class Header {
    constructor() {
        this.header = document.getElementById( 'site-header' );

        if ( ! this.header ) {
            return;
        }

        this.previousScrollposition = window.pageYOffset;

        this.init();
    }

    /**
     * Initializes the events.
     */
    init() {
        const self = this;
        window.addEventListener( 'DOMContentLoaded', () => {
            self.subLevelsWithinViewport();

            if( window.matchMedia( '(min-width: 991px)' ).matches ) {
                hideMobileMenu();
            }
        } );

        window.addEventListener('load', () => self.setSticky() );

        const ww = window.innerWidth || 0;
        window.onresize = function () {
            if ( ww !== window.innerWidth ) {
                self.subLevelsWithinViewport();
            }

            if ( ww !== window.innerWidth && window.matchMedia( '(min-width: 991px)' ).matches ) {
                hideMobileMenu();
            }
        };

        window.onscroll = () => self.setSticky();
    }

    /**
     * Set header sticky.
     * @return void
     */
    setSticky() {
        // Disable sticky-navigation events when the menu is active.
        if ( document.body.classList.contains( 'menu-active' ) ) {
            return;
        }

        let currentScrollPosition = window.scrollY || 0;
        if ( this.previousScrollposition >= currentScrollPosition || currentScrollPosition < this.header.clientHeight ) {
            // Scrolling Up
            document.body.classList.remove( 'is-sticky-hidden' );
            document.body.classList.add( 'is-sticky' );
        } else {
            // Scrolling Down
            document.body.classList.add( 'is-sticky-hidden' );
            document.body.classList.remove( 'is-sticky' );
        }

        this.previousScrollposition = currentScrollPosition;
    }

    /**
     * Check if sub-sub-menu's are within the screen`s viewport.
     * @return void
     */
    subLevelsWithinViewport() {
        this.sublevels = this.header.getElementsByClassName( 'sub-menu--simple' );

        if ( this.sublevels && window.matchMedia( '(min-width: 991px)' ).matches ) {
            this.windowWidth = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;

            this.calculateOffset();
        }
    }

    /**
     * Add Class to element if submenu will be out of the screen.
     * @return void
     */
    calculateOffset() {
        [ ...this.sublevels ]?.forEach( ( sub ) => {
            const rect = sub.getBoundingClientRect();
            if ( rect.right > this.windowWidth && ! sub.classList.contains( 'sub-menu--simple--left' ) ) {
                sub.classList.add( 'sub-menu--simple--left' );
            } else if ( rect.right <= this.windowWidth && sub.classList.contains( 'sub-menu--simple--left' ) ) {
                sub.classList.remove( 'sub-menu--simple--left' );
            }
        } );
    }
}
